import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { BotService } from 'rainbow-web-sdk/services/bot/bot.service';
import { ConversationServiceRB } from 'rainbow-web-sdk/services/conversation/conversation.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { BubbleTagServiceRB } from 'rainbow-web-sdk/services/bubbles/bubbleTag.service';
import { BubbleServiceRB } from '../services/bubbles/bubble.service';

export class BubbleTagPlugin extends Plugin {
    public static initialize(): BubbleTagPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[BubbleTagPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[BubblesPlugin] initialized");
            window.rainbow.plugins[BubbleTagPlugin.name] = new BubbleTagPlugin();
            BotService.getInstance();
            ConversationServiceRB.getInstance();
            BubbleServiceRB.getInstance();
            BubbleTagServiceRB.getInstance();
        }

        return window.rainbow.plugins[BubbleTagPlugin.name];
    }

    private constructor() {
        super();
    }
}
